<template>
    <svg
        :class="['shrink-0', sizeClass, toneClass]"
        :width="pixelSize"
        :height="pixelSize"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        <path :d="path" />
    </svg>
</template>

<script>
const PATHS = {
    home: 'M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3v-6h6v6h3a1 1 0 001-1V10',
    calendar: 'M8 7V3m8 4V3M3 11h18M5 5h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z',
    user: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
    users: 'M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-2.13a4 4 0 110-8 4 4 0 010 8zm6 0a4 4 0 100-8 4 4 0 000 8z',
    card: 'M3 10h18M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z',
    image: 'M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z',
    activity: 'M22 12h-4l-3 9L9 3l-3 9H2',
    message: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
    door: 'M18 20V6a2 2 0 00-2-2H8a2 2 0 00-2 2v14M2 20h20M14 12h.01',
    bell: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0a3 3 0 11-6 0',
    pill: 'M10.5 20.5a7 7 0 01-9.9-9.9l9.9-9.9a7 7 0 019.9 9.9l-9.9 9.9zM8.5 8.5l7 7',
    inbox: 'M22 12h-6l-2 3h-4l-2-3H2M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z',
    'qr': 'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',
    'log-out': 'M17 16l4-4m0 0l-4-4m4 4H9m4-12v4m-7 13h10a2 2 0 002-2V5a2 2 0 00-2-2H6a2 2 0 00-2 2v14a2 2 0 002 2z',
    'arrow-left': 'M19 12H5M12 19l-7-7 7-7',
    'medical_services': 'M9 3v2H7a2 2 0 00-2 2v2H3v4h2v2a2 2 0 002 2h2v2h4v-2h2a2 2 0 002-2v-2h2V9h-2V7a2 2 0 00-2-2h-2V3M19 13a4 4 0 11-8 0 4 4 0 018 0zM17 13a2 2 0 10-4 0 2 2 0 004 0',
    'dashboard': 'M3 5a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2zM13 11a2 2 0 012-2h4a2 2 0 012 2v8a2 2 0 01-2 2h-4a2 2 0 01-2-2zM13 5a2 2 0 012-2h4a2 2 0 012 2v2a2 2 0 01-2 2h-4a2 2 0 01-2-2zM3 15a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2z',
    'child_care': 'M12 4a3 3 0 100-6 3 3 0 000 6zM5 22v-4a3 3 0 013-3h8a3 3 0 013 3v4M9 12h6',
    'group': 'M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-2.13a4 4 0 110-8 4 4 0 010 8zm6 0a4 4 0 100-8 4 4 0 000 8z',
    'group_add': 'M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6 5v-3m-3 3h6M9 14a4 4 0 110-8 4 4 0 010 8zm6 0a4 4 0 100-8 4 4 0 000 8z',
    'campaign': 'M3 11v2a4 4 0 004 4h2l5 4V5L9 9H7a4 4 0 00-4 2zM19 8a4 4 0 010 8',
    'calendar_month': 'M3 6h18M8 2v4M16 2v4M3 10h18v10a2 2 0 01-2 2H5a2 2 0 01-2-2zM8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01',
    'payments': 'M2 7h20v12a2 2 0 01-2 2H4a2 2 0 01-2-2zM2 11h20M7 15h2',
    'logout': 'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9',
    'location_on': 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0zM12 13a3 3 0 100-6 3 3 0 000 6z',
    'search': 'M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z',
    'calendar_today': 'M3 6h18M8 2v4M16 2v4M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2zM12 11v4M10 13h4',
    'notifications': 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0a3 3 0 11-6 0',
    'error': 'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01',
    'check_circle': 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    'trending_up': 'M3 17l6-6 4 4 8-8M14 7h7v7',
    'school': 'M22 10L12 4 2 10l10 6 10-6zM6 12v5c0 2 6 3 6 3s6-1 6-3v-5',
    'badge': 'M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z',
    'auto_graph': 'M3 21h18M3 17l5-5 4 4 9-9M17 7h4v4',
    'account_balance': 'M3 21h18M3 10h18M12 3L3 10h18zM7 10v8M11 10v8M13 10v8M17 10v8',
    'account_balance_wallet': 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2v-3H17a3 3 0 010-6h4V7a2 2 0 00-2-2H5a2 2 0 00-2 2zM17 13a1 1 0 100 2h5v-2z',
    'person_add': 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14M19 8v6M22 11h-6',
    'event': 'M3 6h18M8 2v4M16 2v4M5 4h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2zM3 10h18',
    'arrow-right': 'M5 12h14M12 5l7 7-7 7',
    'lock': 'M5 11h14a1 1 0 011 1v9a1 1 0 01-1 1H5a1 1 0 01-1-1v-9a1 1 0 011-1zM8 11V7a4 4 0 118 0v4',
    'clock': 'M12 22a10 10 0 100-20 10 10 0 000 20zM12 6v6l4 2',
    'megaphone': 'M3 11v2a4 4 0 004 4h2l5 4V5L9 9H7a4 4 0 00-4 2zM19 8a4 4 0 010 8',
    'user-plus': 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14M19 8v6M22 11h-6',
    'help': 'M12 22a10 10 0 100-20 10 10 0 000 20zM9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01',
    'payments': 'M12 2v20M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6',
    'campaign': 'M3 11l18-7v16L3 13M11 13v5a2 2 0 01-4 0v-4',
    'medication': 'M10.5 20.5a7 7 0 01-9.9-9.9l9.9-9.9a7 7 0 019.9 9.9zM3.5 12.5l7 7',
    'signal_cellular_4_bar': 'M2 22h20V2z',
    'wifi': 'M5 12.55a11 11 0 0114 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 6 0 016.95 0M12 20h.01',
    'battery': 'M2 8h18v8H2zM22 11v2',
    'battery_full': 'M2 8h18v8H2zM22 11v2M5 10v4M9 10v4M13 10v4',
    'meeting_room': 'M3 19V5a2 2 0 012-2h8v18M3 19h18M9 9h.01M9 13h.01M9 17h.01',
    'chevron-left': 'M15 18l-6-6 6-6',
    'chevron-right': 'M9 18l6-6-6-6',
    'chevron-down': 'M6 9l6 6 6-6',
    'chevron-up': 'M18 15l-6-6-6 6',
    close: 'M6 18L18 6M6 6l12 12',
    check: 'M5 13l4 4L19 7',
    plus: 'M12 5v14M5 12h14',
    'alert-triangle': 'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01',
    info: 'M12 16v-4M12 8h.01M22 12a10 10 0 11-20 0 10 10 0 0120 0z',
    'check-circle': 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
    'x-circle': 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z',
    'star': 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
    camera: 'M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2zM12 17a4 4 0 100-8 4 4 0 000 8z',
    'search': 'M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z',
    moon: 'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z',
    'cloud-off': 'M1 1l22 22M16 16H5a4 4 0 01-.67-7.95M9 5a5 5 0 016.93 5.97M19 13.5A4.5 4.5 0 0019 9',
    'arrow-up-right': 'M7 17L17 7M7 7h10v10',
    download: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3',
    edit: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z',
    trash: 'M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2',
    menu: 'M3 6h18M3 12h18M3 18h18',
    'file-text': 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8',
    shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
    'sun': 'M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42M12 5a7 7 0 100 14 7 7 0 000-14z',
    sparkles: 'M12 3l1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2L12 3zM19 16l.9 2.8L23 20l-3.1 1.2L19 24l-.9-2.8L15 20l3.1-1.2L19 16z',
    heart: 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z',
    utensils: 'M3 2v7c0 1.1.9 2 2 2h2v11h2V2H3zM7 2v7M21 2v7c0 1.1-.9 2-2 2h-2v11h-2V2h6z',
    'book-open': 'M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z',
    bed: 'M2 9V4a2 2 0 012-2h16a2 2 0 012 2v5M2 11h20v8h-4v-4H6v4H2zM8 7h.01M12 7h.01',
    'hand-wave': 'M7 11V5a2 2 0 014 0v6m0 0V3a2 2 0 014 0v8m0 0V5a2 2 0 014 0v8a8 8 0 01-14 4l-2-3',
    upload: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12',
    'shield-alert': 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM12 8v4M12 16h.01',
    flag: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22V15',
    zap: 'M13 2L3 14h9l-1 8 10-12h-9l1-8z',
    dialpad: 'M5 5h2v2H5zM11 5h2v2h-2zM17 5h2v2h-2zM5 11h2v2H5zM11 11h2v2h-2zM17 11h2v2h-2zM5 17h2v2H5zM11 17h2v2h-2zM17 17h2v2h-2z',
    contactless: 'M5 4a8 8 0 010 16M8 7a5 5 0 010 10M12 10a2 2 0 010 4M3 1l18 22',
    shield_alert: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM12 8v4M12 16h.01',
};

export default {
    name: 'Icon',
    props: {
        name: { type: String, required: true },
        size: {
            type: String,
            default: 'md',
            validator: (v) => ['xs', 'sm', 'md', 'lg', 'xl'].includes(v),
        },
        tone: {
            type: String,
            default: 'default',
            validator: (v) => ['default', 'muted', 'inverse', 'primary', 'success', 'warning', 'danger', 'info'].includes(v),
        },
    },
    computed: {
        pixelSize() {
            return {
                xs: 12,
                sm: 16,
                md: 20,
                lg: 24,
                xl: 32,
            }[this.size];
        },
        path() {
            return PATHS[this.name] || PATHS.info;
        },
        sizeClass() {
            return {
                xs: 'w-3 h-3',
                sm: 'w-4 h-4',
                md: 'w-5 h-5',
                lg: 'w-6 h-6',
                xl: 'w-8 h-8',
            }[this.size];
        },
        toneClass() {
            return {
                default: 'text-stone-700',
                muted: 'text-stone-400',
                inverse: 'text-white',
                primary: 'text-amber-600',
                success: 'text-emerald-600',
                warning: 'text-amber-600',
                danger: 'text-rose-600',
                info: 'text-indigo-600',
            }[this.tone];
        },
    },
};
</script>
